import { useMutation, useQueryClient } from 'react-query';

import { createPeriodReport as createReport } from 'api/periodReports/createPeriodReport';

const useCreatePeriodReport = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: createPeriodReport,
    isLoading,
  } = useMutation(createReport, {
    onSuccess: () => {
      queryClient.invalidateQueries('periodReports');
    },
  });

  return {
    isSuccess,
    createPeriodReport,
    isLoading,
  };
};

export default useCreatePeriodReport;
